import { useTranslation } from "react-i18next";
import { Avatar, Button, Col, Empty, Form, Row, Select, Spin, Switch, Table, TableColumnsType, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent, useEffect, useState } from "react";
import FormInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { get } from "lodash";
import { getAddressDistrictsByProvinceId, getAddressWardsByDistrictId } from "../../../../../service/category-management/university-management";
import { useWatch } from "antd/es/form/Form";
import MemberUniversityModal from "./MemberUniversityModal";
import { getCourseLevel } from "../../../../../service/course-construct";
import { DeleteOutlined } from "@ant-design/icons";

type FormCreateUniversityProps = {
  form: FormInstance,
  onFinish?: any,
  dataOptions?: any,
  loadingForm: boolean,
  onMemberUniversityChange?: (data: any[]) => void;
}

const FormCreateUniversity: FunctionComponent<FormCreateUniversityProps> = ({ form, onFinish, dataOptions, loadingForm, onMemberUniversityChange }) => {
  const { t } = useTranslation();

  const validations = {
  name: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (value && value.length > 512) {
        return Promise.reject(new Error(t("Tên cơ sở đào tạo không vượt quá 512 ký tự", "Tên cơ sở đào tạo không vượt quá 512 ký tự")))
      }
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng nhập tên cơ sở đào tạo", "Vui lòng nhập tên cơ sở đào tạo")))
      }
      return Promise.resolve()
    }
  },
  code: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (value && value.length > 512) {
        return Promise.reject(new Error(t("Mã cơ sở đào tạo không vượt quá 512 ký tự", "Mã cơ sở đào tạo không vượt quá 512 ký tự")))
      }
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng nhập mã cơ sở đào tạo", "Vui lòng nhập mã cơ sở đào tạo")))
      }
      return Promise.resolve()
    }
  },
  modalType: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng chọn loại hình", "Vui lòng chọn loại hình")))
      }
      return Promise.resolve()
    }
  },
  trainingType: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng chọn loại cơ sở đào tạo", "Vui lòng chọn loại cơ sở đào tạo")))
      }
      return Promise.resolve()
    }
  },
  province: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng chọn Tỉnh/TP", "Vui lòng chọn Tỉnh/TP")))
      }
      return Promise.resolve()
    }
  },
  district: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng chọn Quận/huyện", "Vui lòng chọn Quận/huyện")))
      }
      return Promise.resolve()
    }
  },
  ward: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng chọn Phường/xã/thị trấn", "Vui lòng chọn Phường/xã/thị trấn")))
      }
      return Promise.resolve()
    }
  },
  managementAgency: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng chọn cơ quan quản lý trực tiếp", "Vui lòng chọn cơ quan quản lý trực tiếp")))
      }
      return Promise.resolve()
    }
  },
  address: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (value && value.length > 512) {
        return Promise.reject(new Error(t("Địa chỉ không vượt quá 512 ký tự", "Địa chỉ không vượt quá 512 ký tự")))
      }
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng nhập địa chỉ", "Vui lòng nhập địa chỉ")))
      }
      return Promise.resolve()
    }
  },
}

  const [dataDistricts, setDataDistricts] = useState([]);
  const [dataWards, setDataWards] = useState([]);
  const proviceData = useWatch("province", form);
  const districtData = useWatch("district", form);
  const [selectedTrainingType, setSelectedTrainingType] = useState<string>("");
  const [isOpenMemberUniversityModal, setIsOpenMemberUniversityModal] = useState<boolean>(false)
  const [memberUniversity, setMemberUniversity] = useState<any>([])
  const [trainingLevelList, setTrainingLevelList] = useState<any>([])

  const handleChangeProvince = (e: any) => {
    // getDistricts(e);
    setDataWards([]);
    form.setFieldsValue({
      district: null,
      ward: null,
    })
  }

  const handleChangeDistrict = (e: any) => {
    form.setFieldsValue({
      ward: null,
    })
    // getWards(e);
  }

  // Get districts API
  const getDistricts = async (provinceId: string) => {
    try {
      await getAddressDistrictsByProvinceId(provinceId).then((res) => {
        const districts = res.data.data.map((item: any) => {
          return ({
            id: item.code,
            name: item.name,
          })
        })
        setDataDistricts(districts);
      })
    } catch (err) {
      console.error(err)
    }
  }

  // Get wards API
  const getWards = async (provinceId: string) => {
    try {
      await getAddressWardsByDistrictId(provinceId).then((res) => {
        const wards = res.data.data.map((item: any) => {
          return ({
            id: item.code,
            name: item.name,
          })
        })
        setDataWards(wards);
      })
    } catch (err) {
      console.error(err)
    }
  }

  // get districts by 
  useEffect(() => {
    if (proviceData) {
      getDistricts(proviceData);
    } else {
      setDataDistricts([]);
    }
  }, [proviceData])

  // get wards by district
  useEffect(() => {
    if (districtData) {
      getWards(districtData);
    } else {
      setDataWards([]);
    }
  }, [districtData])

  useEffect(() => {
    const fetchCourseLevel = async () => {
      try {
        const res = await getCourseLevel()
        setTrainingLevelList(res.data.data.map((item: any) => {
          return ({
            value: item.id,
            label: item.name,
          })
        }))
      } catch (error) {

      }
    }
    fetchCourseLevel()
  }, [])


  function normalizeString(str: string): string {
    return str
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  useEffect(() => {
    setSelectedTrainingType(form.getFieldValue("type"))
  }, [form.getFieldValue("type")])

  useEffect(() => {
    setMemberUniversity(form.getFieldValue("children"))
  }, [form.getFieldValue("children")])

  useEffect(() => {
    if (onMemberUniversityChange) {
      onMemberUniversityChange(memberUniversity);
    }
  }, [memberUniversity]);

  const handleRemoveUniversity = (id: string) => {
    const updatedMemberUniversity = memberUniversity.filter(
      (university: any) => university.enterpriseId !== id
    );
    setMemberUniversity(updatedMemberUniversity);
  };
  const locale = {
    emptyText: <Empty description={t("Không có kết quả", "Không có kết quả")} />,
  };
  const columns: TableColumnsType<any> = [
    {
      title: t('STT', 'STT'),
      dataIndex: 'numericalOrder',
      key: 'numericalOrder',
      width: 50,
      render: (_: any, record, index: number) => {
        return <div>{index + 1}</div>;
      },
    },
    {
      title: t('Mã trường', 'Mã trường'),
      dataIndex: 'code',
      key: 'code',
      width: 80,
    },
    {
      title: t('Tên trường', 'Tên trường'),
      dataIndex: 'name',
      key: 'name',
      width: 200,
      render: (_: any, record, index: number) => {
        return <div className="flex align-center gap-8"><Avatar shape="square" size="small" src={record?.logo} /> {record?.name}</div>;
      },
    },
    {
      title: t('Thao tác', 'Thao tác'),
      dataIndex: 'action',
      key: 'action',
      width: 60,
      render: (_: any, record, index: number) => {

        return <Button
          type="link"
          danger
          onClick={() => handleRemoveUniversity(record.enterpriseId)}
        >
          <DeleteOutlined />
        </Button>
      },
    },
  ];
  return (
    <>
      <Form layout={"vertical"} form={form} onFinish={onFinish} name="createUniversity" initialValues={{ status: true }}>
        {loadingForm ?
          <div className="statistic-course-content statistic-course-loading">
            <Spin size="large" />
          </div>
          :
          <Row gutter={[16, 16]}>
            <div className="w-full">
              <h2 className="pt-2 pb-2">{t("Cơ sở giáo dục đào tạo", "Cơ sở giáo dục đào tạo")}</h2>
              <Col span={24}>
                <Form.Item name="code" rules={[validations.code]} label={t("Mã cơ sở đào tạo", "Mã cơ sở đào tạo")}>
                  <FormInput placeholder={t("Nhập mã cơ sở đào tạo", "Nhập mã cơ sở đào tạo")} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="name" rules={[validations.name]} label={t("Tên cơ sở đào tạo", "Tên cơ sở đào tạo")}>
                  <FormInput placeholder={t("Nhập tên cơ sở đào tạo", "Nhập tên cơ sở đào tạo")} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="englishName" label={t("Tên tiếng Anh", "Tên tiếng Anh")}>
                  <FormInput placeholder={t("Nhập tên tiếng anh của cơ sở đào tạo", "Nhập tên tiếng anh của cơ sở đào tạo")} />
                </Form.Item>
              </Col>
              <div className="hr-tag-m0"></div>
            </div>
            <div className="w-full flex flex-wrap">
              <Col span={24}><h2 className="pt-2 pb-2">{t("Loại hình", "Loại hình")}</h2></Col>
              <Col span={12}>
                <Form.Item name="modalType" rules={[validations.modalType]} label={t("Loại hình", "Loại hình")}>
                  <FormItemDropdown options={get(dataOptions, 'dataTrainingType', '')} allowClear={true} placeholder={t("Chọn loại hình", "Chọn loại hình")} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="trainingType" rules={[validations.trainingType]} label={t("Loại cơ sở giáo dục đại học", "Loại cơ sở giáo dục đại học")}>
                  <FormItemDropdown options={get(dataOptions, 'dataModalType', '')} allowClear={true} placeholder={t("Chọn loại cơ sở giáo dục đại học", "Chọn loại cơ sở giáo dục đại học")}
                    onChange={e => setSelectedTrainingType(e)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div className="hr-tag-m0"></div>
              </Col>
            </div>
            {normalizeString(selectedTrainingType) === normalizeString("Đại học") /* type */ && (<div className="w-full flex flex-wrap">
              <Col span={24}>
                <div className="flex align-center justify-between">
                  <h2 className="pt-2 pb-2">{t("Trường đại học thành viên", "Trường đại học thành viên")}</h2>
                  <Button
                    onClick={() => setIsOpenMemberUniversityModal(true)}
                  >{t("Thêm trường đại học thành viên", "Thêm trường đại học thành viên")}</Button>
                </div>
              </Col>
              <Col>{t("Có", "Có")} {memberUniversity?.length || 0} {t("trường đại học thành viên", "trường đại học thành viên")}</Col>
              <Table
                columns={columns}
                dataSource={memberUniversity}
                pagination={false}
                rowKey="id"
                scroll={{ x: 600, y: 600 }}
                locale={locale}
              />

              {/* <Col span={24}>
                <div className="hr-tag-m0 mt-2"></div>
              </Col> */}
            </div>)}
            <div className="w-full flex flex-wrap">
              <Col span={24}><h2 className="pt-2 pb-2">{t("Địa chỉ", "Địa chỉ")}</h2></Col>
              <Col span={12}>
                <Form.Item name="province" rules={[validations.province]} label={t("Tỉnh/TP", "Tỉnh/TP")}>
                  <FormItemDropdown options={get(dataOptions, 'dataProvince', '')}
                    onChange={(e) => handleChangeProvince(e)} placeholder={t("Chọn Tỉnh/TP", "Chọn Tỉnh/TP")} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="district" rules={[validations.district]} label={t("Quận/huyện", "Quận/huyện")}>
                  <FormItemDropdown options={dataDistricts}
                    onChange={(e) => handleChangeDistrict(e)} placeholder={t("Chọn Quận/huyện", "Chọn Quận/huyện")} />
                </Form.Item>
              </Col>
              {/* <Col span={12}>
							<Form.Item name="principal" label={t("Hiệu trưởng", "Hiệu trưởng")}>
								<FormInput placeholder={t("Nhập tên hiệu trưởng", "Nhập tên hiệu trưởng")} />
							</Form.Item>
						</Col> */}
              <Col span={12}>
                <Form.Item name="ward" rules={[validations.ward]} label={t("Phường/xã/thị trấn", "Phường/xã/thị trấn")}>
                  <FormItemDropdown options={dataWards} placeholder={t("Chọn Phường/xã/thị trấn", "Chọn Phường/xã/thị trấn")} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  rules={[validations.address]}
                  name="address" label={t("Địa chỉ", "Địa chỉ")}>
                  <FormInput placeholder={t("Nhập địa chỉ", "Nhập địa chỉ")} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="website" label={t("Website", "Website")}>
                  <FormInput placeholder={t("Nhập website", "Nhập website")} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div className="hr-tag-m0"></div>
              </Col>
            </div>
            <Col span={24} style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{t("Trạng thái", "Trạng thái")}</span>
              <Form.Item name="status">
                <Switch defaultChecked />
              </Form.Item>
            </Col>
          </Row>
        }
        <MemberUniversityModal
          open={isOpenMemberUniversityModal}
          handleCancel={() => setIsOpenMemberUniversityModal(false)}
          setMemberUniversity={setMemberUniversity}
          memberUniversity={memberUniversity}
        />
      </Form>
    </>
  )
}

export default FormCreateUniversity;